
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ImageTemp, ImageType } from '../../interfaces/intakes.reports';

interface Props{
    image: ImageTemp | ImageType
}

export function SortableImage({ image }: Props) {
  const id = 'id' in image ? image.id : image.key;
  const url = 'url' in image ? image.url : image.imgURL_low;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // borderRadius: '5px',
    // display: 'inline-block',
    cursor: 'grab',
    aspectRatio: "1",
    overflow: 'hidden',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <img src={url} alt={`Image ${id}`} style={{ width: '100%', height: '100%', objectFit: 'cover'}} />
    </div>
  );
}